import { SideNavigationProps } from "@amzn/awsui-components-react/polaris/side-navigation";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useJeAccrualYearMonthFilters } from "../../features/je-accrual-year-month-filters";

/**
 * Hook for handling side navigation events
 */
export const useOnFollowHandler = () => {
  const navigate = useNavigate();

  return (event: CustomEvent<SideNavigationProps.FollowDetail>) => {
    if (!event.detail.external) {
      event.preventDefault();
      navigate(event.detail.href, { replace: true });
    }
  };
};

export const useNavConfig = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { jeAccrualYearMonthFilters } = useJeAccrualYearMonthFilters();

  const utaVRItem = {
    type: "link",
    text: t("pages.home.reporting"),
    href: "/reporting",
  };

  const businessRulesItems = {
    type: "link",
    text: t("pages.home.business_rules"),
    href: "/business-rules",
  };

  const dataOrchestrationItems = {
    type: "link",
    text: t("pages.home.data_orchestration"),
    href: "/data-orchestration",
  };

  const jeAccrualItem = {
    type: "link",
    text: t("pages.home.je_accrual"),
    href: `/je-accrual?year=${
      jeAccrualYearMonthFilters.year
    }&month=${jeAccrualYearMonthFilters.month.toUpperCase()}#assignments`,
  };

  const monthlyInsightsItem = {
    type: "link",
    text: t("pages.monthly_insights.title"),
    href: "/monthly-insights",
  };

  const chatAgentItem = {
    type: "link",
    text: t("pages.chat_agent.title"),
    href: "/chat-agent",
  };

  return {
    header: {
      href: "",
      text: t("left_nav.title"),
    } as SideNavigationProps.Header,
    items: [
      { type: "link", text: t("pages.home.title"), href: "/" },
      {
        type: "link",
        text: t("pages.home.calculate_taxes"),
        href: "/calculate-taxes",
      },
      jeAccrualItem,
      businessRulesItems,
      dataOrchestrationItems,
      monthlyInsightsItem,
      chatAgentItem,
      utaVRItem,
    ] as SideNavigationProps.Item[],
    activeHref: location.pathname + location.search,
  };
};
